import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams, Platform} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";
import {Storage} from "@ionic/storage";
import {errorHandler} from "@angular/platform-browser/src/browser";
import {PreviousSchoolsStudentsPage} from "../previous-schools-students/previous-schools-students";


@Component({
    selector: 'page-previous-schools',
    templateUrl: 'previous-schools.html',
})
export class PreviousSchoolsPage {

    FUserId:any;
    SchoolData:any;
    SchoolData1:any;
    DataSearch:any;

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public service: ServiceProvider,
                public platform: Platform,
                public storage: Storage) {
        this.platform.ready().then(() => {
            Promise.all([this.storage.get('LoginData'), this.storage.get('UserData')]).then(values => {
                this.FUserId = values[0]['FUserId'];

                this.loadSchool();
            })
        })
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad PreviousSchoolsPage');
    }

    loadSchool(){
        this.SchoolData=[];
        this.service.httpcall('app_web_service/get_previous_schools_details?FUserId='+this.FUserId).subscribe(data => {
            console.log(data);
           if(data['response']=='success'){
               this.SchoolData1 = data['data'];
               this.SchoolData = this.SchoolData1;
           }else{
                this.service.showAlert(data['response'],data['error_description']);
           }
        },error =>{
            this.service.showAlert('Timeout',"Please Try Again!");
        })
    }

    doRefresh(refresher) {
        console.log('Begin async operation', refresher);

        this.loadSchool();
        setTimeout(() => {
            console.log('Async operation has ended');

            refresher.complete();
        }, 2000);
    }

    searchData(ev: any) {
        // Reset items back to all of the items
        this.SchoolData = this.SchoolData1;
        // set val to the value of the searchbar
        let val = ev.target.value;
        // if the value is an empty string don't filter the items
        if (val && val.trim() != '') {
            this.SchoolData = this.SchoolData.filter((item) => {
                return (item.Name.toLowerCase().indexOf(val.toLowerCase()) > -1);
            })
        }

    }

    go_to_studentDetails(item){
        this.navCtrl.push(PreviousSchoolsStudentsPage, {'FSchoolId': item.FSchoolId, 'FPreviousSchoolId': item.Id});
    }
}



// WEBPACK FOOTER //
// ./src/pages/previous-schools/previous-schools.ts